















import LoadingPage from '@/components/LoadingPage.vue';
import { Button, Icon, Toast } from '@descomplica/vue-components';
import Vue from 'vue';
import { PaymentInfoTrackingModel } from '../../../../helpers/paymentInfoTracking';
import { AnalyticsActions } from '../../../../store/modules/analytics/actions';
import { PixData } from '../../../../store/modules/payment/state';
import Analytics from '@/helpers/analytics';
import { Course } from '@/store/modules/enrollment/state';

export default Vue.extend({
  components: {
    Button,
    Icon,
    LoadingPage,
    Toast,
  },
  props: {
    paymentInfoTracking: {
      type: Object as () => PaymentInfoTrackingModel,
      required: true,
    },
  },
  data() {
    return { isLoading: false, error: false };
  },
  computed: {
    getPixData(): PixData {
      return this.$store.getters.pixData;
    },
    studentAcademicRecord(): string {
      return this.$store.getters.backofficeStudentAcademicRecord;
    },
    studentEmail(): string {
      return this.$store.getters.personalData?.email || '';
    },
    enrollmentId(): string {
      return this.$store.getters.enrollmentId;
    },
    course(): Course {
      return this.$store.getters.course;
    },
  },
  methods: {
    async generateQrCode() {
      try {
        this.isLoading = true;

        await this.$store.dispatch('GENERATE_PIX_DATA');

        this.$emit('enablePix');

        await this.$store.dispatch(AnalyticsActions.PAYMENT_SENT, {
          paymentMethod: 'Pix',
          academicRecordId: this.studentAcademicRecord,
          ...this.paymentInfoTracking,
        });

        Analytics.trackEcommerceTransaction(this.enrollmentId, this.course, {
          academicRecordId: this.studentAcademicRecord,
          paymentMethod: 'Pix',
          email: this.studentEmail,
          ...this.paymentInfoTracking,
        });
      } catch (err) {
        this.error = true;
        setTimeout(() => {
          this.error = false;
          if (window && window.bmMaximize) {
            window.bmMaximize();
          }
        }, 3000);
        throw err;
      } finally {
        this.isLoading = false;
      }
    },
  },
});
